import { useNavigate, useParams } from 'react-router-dom';
import './oildetail.css';

const flourData = {
  ragi: {
    name: 'Ragi Flour',
    image: '/images/flours/ragi.webp',
    description:
      'Ragi Flour, known as Kezhvaragu Maavu (கேழ்வரகு மாவு) in Tamil, is made by grinding finger millet grown widely in Dharmapuri, Salem, Krishnagiri, and Vellore regions of Tamil Nadu. It is a time-honored ingredient in Tamil cuisine, known for its rich calcium, iron, and fiber content. Traditionally used in dishes like ragi kali, dosa, puttu, and kanji, Tamil people believe ragi flour helps strengthen bones, manage diabetes, and cool the body. It is especially recommended for children, women, and the elderly, and continues to be a symbol of wholesome village nutrition and health.',
  },
  idiyappam: {
    name: 'Idiyappam Flour',
    image: '/images/flours/idiyapam.webp',
    description:
      'Idiyappam Flour, known as Idiyappam Maavu (இடியாப்பம் மாவு) in Tamil, is made from finely milled, parboiled rice—traditionally prepared in Tamil Nadu households using varieties like Ponni or Raw Rice. The flour is steamed and pressed into soft, thin noodles called Idiyappam or String Hoppers. In Tamil homes, idiyappam is considered a light, easily digestible meal, commonly served with coconut milk, vegetable stew, or kurma. It is especially popular in Tirunelveli, Nagercoil, and coastal regions. Tamil people believe it’s a wholesome, gluten-free option that’s gentle on the stomach, making it ideal for breakfast or dinner.',
  },
  puttu: {
    name: 'Puttu Flour',
    image: '/images/flours/puttu.webp',
    description:
      'Puttu Flour, known as Puttu Maavu (புட்டு மாவு) in Tamil, is made by roasting and grinding parboiled rice—a time-honored method in Tamil Nadu, especially in southern districts like Tirunelveli and Nagercoil. The flour is lightly moistened and steamed to prepare Puttu, a soft, fluffy dish. In Tamil culture, puttu is enjoyed as a nutritious and filling breakfast, often paired with coconut, jaggery, banana, or kadala curry. It is believed to be easily digestible, gluten-free, and rich in complex carbohydrates, making it ideal for all age groups and part of a balanced, traditional diet.',
  },
  sambaputtu: {
    name: 'Samba Puttu Flour',
    image: '/images/flours/samba.webp',
    description:
      'Samba Puttu Flour, known as Samba Puttu Maavu (சாம்பா புட்டு மாவு) in Tamil, is made by roasting and grinding Samba rice, a traditional red rice variety grown in regions like Thanjavur and Trichy. It is coarser and more fibrous than regular puttu flour, offering a nutty flavor and rich texture. In Tamil homes, samba puttu is valued for being high in fiber, iron, and slow-releasing energy. It is believed to aid digestion, regulate blood sugar, and promote gut health. Usually served with jaggery, banana, grated coconut, or black channa curry, samba puttu is a hearty, traditional breakfast with deep roots in Tamil food culture.',
  },
  kozhakkattai: {
    name: 'Kozhakkattai Flour',
    image: '/images/flours/kozhakkattai.webp',
    description:
      'Kozhakkattai Flour, known as Kozhukkattai Maavu (கொழுக்கட்டை மாவு) in Tamil, is made from finely ground, smooth rice flour, usually using traditional rice varieties like Ponni or Maavu Arisi. This flour is commonly prepared fresh at home or sourced during festival times in Tamil Nadu, especially around Ganesh Chaturthi. In Tamil culture, kozhukkattai is considered a sacred and wholesome food, often steamed and stuffed with jaggery, coconut, or spicy fillings. The flour is prized for being light, gluten-free, and easily digestible. Tamil people believe it promotes gut health and energy while being a pure offering in religious rituals.',
  },
  murukku: {
    name: 'Murukku Flour',
    image: '/images/flours/muruku.webp',
    description:
      'Murukku Flour, known as Murukku Maavu (முறுக்கு மாவு) in Tamil, is made by mixing finely ground rice flour (usually from raw rice) with urad dal flour—both traditionally roasted and sieved to perfection. This blend is especially popular in southern Tamil Nadu, where homemade murukku is a festive favorite. In Tamil culture, murukku is more than a snack—its a symbol of celebration during Diwali, weddings, and other auspicious events. The flour is valued for producing crispy, golden spirals that are light yet satisfying. It is believed to be easily digestible and is often prepared with jeera, sesame seeds, and a touch of ghee or butter for extra flavor.',
  },
  pearlmillet: {
    name: 'Pearl Millet Flour',
    image: '/images/flours/pearl.webp',
    description:
      'Pearl Millet Flour, known as Kambu Maavu (கம்பு மாவு) in Tamil, is made by grinding Kambu (Pearl Millet)—a resilient grain grown widely in dry regions like Virudhunagar, Sivagangai, and Ramanathapuram. It’s an ancient grain celebrated in Tamil village diets. In Tamil homes, kambu maavu is used to prepare dishes like kambu koozh (fermented porridge), dosa, and rotti. It is believed to cool the body, aid digestion, and strengthen bones due to its rich calcium, fiber, and iron content. Valued as a summer superfood, pearl millet flour is a staple for sustained energy and rural nourishment.',
  },
  besan: {
    name: 'Besan Flour',
    image: '/images/flours/besan.webp',
    description:
      'Besan Flour, known as Kadalai Maavu (கடலை மாவு) in Tamil, is made by grinding roasted or raw Bengal gram (channa dal), commonly sourced from regions like Salem, Erode, and Dharmapuri. It is a versatile flour used in both sweet and savory Tamil recipes. In Tamil cuisine, kadalai maavu is used in dishes like bondas, bajjis, pakkodas, and burfis. It is believed to be rich in protein, help in muscle building, and keep you full longer. Also used in traditional skincare routines, besan is valued not just for cooking, but for its cooling and cleansing properties in Tamil households.',
  }
};


const FlourDetail = () => {
  const { type } = useParams();
  const flour = flourData[type];
  const navigate = useNavigate();
  const goToProducts = () => {
        navigate('/flours');
    };

  if (!flour) return <h2>Flour product not found</h2>;

  return (
    <section
      className="sesame-section"
      style={{ backgroundImage: `url(${flour.image})` }}
    >
      <div className="sesame-content">
        <div className="text-content">
          <button className='back-btn-viewmore' onClick={goToProducts}>⟵ Back to Flours Products</button>
          <h2>{flour.name}</h2>
          <p>{flour.description}</p>
        </div>
        <div className="button-box">
          <button className="enquire-btn">ENQUIRE NOW</button>
        </div>
      </div>
    </section>
  );
};

export default FlourDetail;
